import {
  ALL_LAYOUT_ARGS,
  Arg,
  CONTAINER_ARGS,
  Metadata,
  pick,
  pickAll,
} from '../../../../utils/spds/metadata';
import { WRAP } from '../../../../utils/spds/constants/css-layout';
import { hash } from '@ember/helper';
import Card, { sizes } from '../card.gjs';
import FlexColumn from '../../layout/flex/column.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import GridContainer from '../../layout/grid/container.gjs';
import Super from '../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Container for grouping multiple card components with consistent spacing and layout',
  extends: [
    pick(CONTAINER_ARGS, [
      'column',
      'fitContent',
      'fitContentHeight',
      'fitContentWidth',
      'grid',
      'reverse',
    ]),
    pickAll(ALL_LAYOUT_ARGS, {
      overrides: {
        flexWrap: { default: WRAP },
        gap: { default: '8px' },
      },
    }),
  ],
  meta: {
    size: Arg.string({
      description: 'Size variant to apply to all cards in the group',
      options: sizes,
    }),
  },
  name: 'Card Group',
});

export default class SpdsContainerGroupCard extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-container-group-card';

  get column() {
    return this.argOrDefault('column');
  }

  get component() {
    if (this.grid) return GridContainer;
    return this.column ? FlexColumn : FlexRow;
  }

  get flexWrap() {
    if (this.grid) return 'unset';
    return this.argOrDefault('flexWrap');
  }

  get gap() {
    return this.argOrDefault('gap');
  }

  get grid() {
    return this.argOrDefault('grid');
  }

  <template>
    <this.component
      @alignContent={{@alignContent}}
      @alignItems={{@alignItems}}
      @alignSelf={{@alignSelf}}
      @area={{@area}}
      @areas={{@areas}}
      @autoFlow={{@autoFlow}}
      @columns={{@columns}}
      @flex={{@flex}}
      @flexWrap={{this.flexWrap}}
      @fitContent={{@fitContent}}
      @fitContentHeight={{@fitContentHeight}}
      @fitContentWidth={{@fitContentWidth}}
      @gap={{this.gap}}
      @grid={{this.grid}}
      @gridArea={{@gridArea}}
      @gridAutoColumns={{@gridAutoColumns}}
      @gridAutoFlow={{@gridAutoFlow}}
      @gridAutoRows={{@gridAutoRows}}
      @gridColumn={{@gridColumn}}
      @gridRow={{@gridRow}}
      @gridTemplateAreas={{@gridTemplateAreas}}
      @gridTemplateColumns={{@gridTemplateColumns}}
      @gridTemplateRows={{@gridTemplateRows}}
      @justifyContent={{@justifyContent}}
      @justifyItems={{@justifyItems}}
      @justifySelf={{@justifySelf}}
      @order={{@order}}
      @reverse={{@reverse}}
      @rows={{@rows}}
      class={{this.classes}}
      data-test-spds-container-group-card
      {{this.setupComponent}}
      ...attributes
    >
      {{yield (hash Card=(component Card size=@size))}}
    </this.component>
  </template>
}

export const CARD_GROUP_METADATA = SpdsContainerGroupCard.metadata;
